import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Stack,
  Divider,
} from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const footerLinks = [
    { label: "About Us", href: "/about-us" },
    { label: "Our Courses", href: "/about-us/courses" },
    { label: "Our Staff", href: "/faculty" },
    { label: "Social Outreach", href: "/social-outreach" },
    { label: "Contact", href: "/about-us/admissions" },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#1e1b4b",
        color: "white",
        pt: { xs: 6, md: 8 },
        pb: 3,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <SchoolIcon sx={{ fontSize: 32, color: "warning.main" }} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  letterSpacing: 1,
                }}
              >
                American College
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: "rgba(255, 255, 255, 0.7)",
                mb: 3,
                lineHeight: 1.8,
              }}
            >
              Empowering learners worldwide with quality education and
              innovative learning experiences.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    backgroundColor: "warning.main",
                    color: "primary.main",
                  },
                }}
                href="https://www.facebook.com/collegeiaes"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    backgroundColor: "warning.main",
                    color: "primary.main",
                  },
                }}
                href="https://www.instagram.com/collegeiaes/?hl=es"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                sx={{
                  color: "white",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  "&:hover": {
                    backgroundColor: "warning.main",
                    color: "primary.main",
                  },
                }}
                href="https://www.linkedin.com/company/collegeiaes/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </IconButton>
            </Stack>
          </Grid>

          {/* Explore */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
              }}
            >
              Explore
            </Typography>
            <Stack spacing={1.5}>
              {footerLinks.map((item) => (
                <Link
                  key={item.label}
                  component={RouterLink}
                  to={item.href}
                  underline="none"
                  sx={{
                    color: "rgba(255, 255, 255, 0.7)",
                    "&:hover": { color: "warning.main" },
                    transition: "color 0.3s",
                  }}
                >
                  {item.label}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
              }}
            >
              Contact
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
                <LocationOnIcon
                  sx={{ fontSize: 20, color: "warning.main", mt: 0.3 }}
                />
                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255, 255, 255, 0.7)", lineHeight: 1.6 }}
                >
                  Av. Masferrer Nte. 557, San Salvador, El Salvador
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <PhoneIcon sx={{ fontSize: 20, color: "warning.main" }} />
                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                >
                  +503 7840-5400
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <EmailIcon sx={{ fontSize: 20, color: "warning.main" }} />
                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255, 255, 255, 0.7)" }}
                >
                  institdevelopment@americancollege
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255, 255, 255, 0.1)" }} />

        {/* Bottom Footer */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255, 255, 255, 0.6)",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            © {new Date().getFullYear()} American College. All rights reserved.
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
